<template>
  <div>
    <Header page="dashboard"/>
    <b-container>
      <div class="list-user--table">
        <div class="header-table header-table-custom">
          <h2 class="heading2">
          </h2>
        </div>
      </div>
      <b-row>
        <b-col cols="6" lg="4" class="col-left mb-30">
          <div class="dashboard_admin_statistic dashboard_admin_statistic-green d-flex justify-content-start">
            <img src="@img/admin/db-1.svg" class="dashboard_admin_imgStatistic" />
            <div class="dashboard_admin_statistic_parent">
              <div class="dashboard_statistic_title">会社数</div>
              <div class="dashboard_admin_statistic_number">{{formatNumberDashBoard(dashboard.total_vendors)}}</div>
            </div>
          </div>
        </b-col>
        <b-col cols="6" lg="4" class="col-right mb-30">
          <div class="dashboard_admin_statistic dashboard_admin_statistic-orange d-flex justify-content-start">
            <img src="@img/company-profile/number-file.svg" class="dashboard_admin_imgStatistic" />
            <div class="dashboard_admin_statistic_parent">
              <div class="dashboard_statistic_title">ファイル数</div>
              <div class="dashboard_admin_statistic_number">{{formatNumberDashBoard(dashboard.total_files)}}</div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="dashboard_admin_statistic dashboard_admin_statistic-blue d-flex justify-content-start">
            <img src="@img/admin/db-3.svg" class="dashboard_admin_imgStatistic" />
            <div class="dashboard_admin_statistic_parent">
              <div class="dashboard_statistic_title">30日間にアップロードファイルの数</div>
              <div class="dashboard_admin_statistic_number">{{formatNumberDashBoard(dashboard.total_new_files)}}</div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from '@/components/share/Header'
import {mapState} from 'vuex'
export default {
  name: 'index',
  components: {
    Header
  },
  computed: {
    ...mapState({
      dashboard: state => state.adminDashboard.dashboard
    })
  },
  mounted () {
    this.$store.dispatch('adminDashboard/getDashboard')
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/stylesheet/auth/dashboard.scss';
@import '@/assets/stylesheet/user/list_user.scss';
</style>



// WEBPACK FOOTER //
// src/views/Admin/index.vue